import { DefaultersRecurringFilterForm } from "./recurring-filter-form"
import { DefaultersRecurringTable } from "./recurring-table"

export const DefaultersRecurringTabContent = () => {
  return (
    <section className="flex flex-1 flex-col gap-4">
      <DefaultersRecurringFilterForm />
      <DefaultersRecurringTable />
    </section>
  )
}
